import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

// Bundled tenant fonts. The active tenant's `font_family` (arriving via
// `init.theme`) resolves against the `@font-face` declarations in here.
// See `docs/04-tenants-and-theming.md` §"Bundled fonts".
import './theme/fonts.css';

// Dev-only: synthesises an `init` message so the wizard renders without a host.
// Tree-shakes out of production builds via the `import.meta.env.DEV` guard inside.
import './dev/mockInit';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

const renderApp = (): void => {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

// Dev-only: start the MSW Service Worker so mocked endpoints declared per
// flow (see `apps/forms-host/src/mocks/handlers.ts`) intercept requests under
// `yarn dev`, mirroring the Vitest server setup. Tree-shaken in production.
if (import.meta.env.DEV) {
  void import('./mocks/browser').then(({ worker }) =>
    worker
      .start({ onUnhandledRequest: 'bypass' })
      .finally(renderApp),
  );
} else {
  renderApp();
}
